export default {
    slug: 'frc',
    img: '/img/tr-frc.jpg',
    icon: 'frc',
    en: {
        name: 'FRC (Fibre Reinforced Composite)',
        short: 'Front-tooth replacement that may be considered — without major surgery.',
        metaTitle: 'FRC — Broken or Missing Front Tooth | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Broke or lost a front tooth? Fibre Reinforced Composite (FRC) explained in patient-friendly language — what it is, who it may suit, and what the alternatives are.',
        kicker: 'Restorative',
        heroTitle: 'Broken or missing front tooth? Here is what FRC means — in plain language.',
        heroSub: 'Fibre Reinforced Composite (FRC) is a modern option that may be considered for a missing front tooth or a broken one, in selected situations. We start with the problem — because that is what you are actually searching for.',
        whoIntro: 'Patients who ask us about FRC usually have:',
        who: [
            'A missing front tooth they would like replaced without surgery',
            'A broken front tooth where a fibre-reinforced option may be considered',
            'A wish to understand alternatives to conventional bridges and implants',
        ],
        problem: 'FRC uses a fibre-reinforced structure to rebuild or replace a tooth, using tooth-coloured composite. It is minimally invasive in selected cases. Whether FRC suits you depends on your bite, the position of the tooth and the health of neighbouring teeth — which is exactly what the assessment is for.',
        assessmentIntro: 'How we assess:',
        assessment: [
            'An examination of the broken or missing tooth and its neighbours',
            'A discussion of what you want to achieve, honestly weighed against what is clinically possible',
            'All reasonable options on the table — FRC, zirconia bridge, conventional options',
            'Fees explained in writing before anything is decided',
        ],
        optionsIntro: 'The choices we discuss at assessment:',
        options: [
            { name: 'FRC (Fibre Reinforced Composite)', text: 'A fibre-reinforced, tooth-coloured solution built chairside in selected cases. Minimally invasive — but not suitable for every situation.' },
            { name: 'Zirconia bridge', text: 'A strong ceramic bridge may be considered instead, depending on your clinical condition. See our zirconia page.' },
            { name: 'Other options', text: 'Conventional bridges or other approaches may be more appropriate for some patients. The assessment decides, not the marketing.' },
        ],
        knowIntro: 'What patients should know:',
        know: [
            'FRC is not suitable for every case — bite forces, tooth position and neighbouring teeth all matter',
            'It is often completed without drilling down neighbouring teeth — but whether that applies to you is a clinical question, not a promise',
            'Care and longevity vary by case; your doctor will explain what FRC can and cannot offer in your situation',
        ],
        followup: 'FRC work is reviewed like any restoration: at routine visits, and whenever you notice a change. Contact the clinic if anything feels different.',
        faqs: [
            { q: 'I broke my front tooth — what are my options?', a: 'Options may include FRC, a crown, a bridge or other approaches, depending on how the tooth broke and its overall health. Come in for an assessment — we will lay the options out honestly.' },
            { q: 'Is FRC only for front teeth?', a: 'FRC is mostly discussed for front-tooth situations, where bite forces are smaller. Whether it suits a different area of your mouth is a clinical question for the assessment.' },
            { q: 'How long does an FRC bridge last?', a: 'It varies by case, bite and home care. No honest dentist quotes a fixed lifespan without examining you — we will tell you what your specific situation suggests.' },
            { q: 'Is the procedure painful?', a: 'FRC work is generally a gentle procedure in selected cases, but every mouth is different. We explain what to expect before anything begins — you decide from there.' },
        ],
        intlNote: 'Selected restorative treatments — including FRC — are among the reasons patients from Indonesia/Batam visit the clinic. See the Indonesia/Batam page.',
    },
    ms: {
        name: 'FRC (Fibre Reinforced Composite)',
        short: 'Ganti gigi depan yang mungkin dipertimbangkan — tanpa pembedahan besar.',
        metaTitle: 'FRC — Gigi Depan Patah atau Hilang | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Gigi depan patah atau hilang? Fibre Reinforced Composite (FRC) dijelaskan dengan bahasa mudah — apa itu, untuk siapa, dan apakah pilihan lain.',
        kicker: 'Restoratif',
        heroTitle: 'Gigi depan patah atau hilang? Ini maksud FRC — dalam bahasa yang mudah.',
        heroSub: 'Fibre Reinforced Composite (FRC) ialah pilihan moden yang mungkin dipertimbangkan untuk gigi depan yang hilang atau patah, dalam situasi tertentu. Kami mulakan dengan masalah anda — kerana itu yang anda sedang cari.',
        whoIntro: 'Pesakit yang bertanya tentang FRC biasanya menghadapi:',
        who: [
            'Gigi depan hilang yang mahu diganti tanpa pembedahan',
            'Gigi depan patah di mana pilihan fibre-reinforced mungkin dipertimbangkan',
            'Ingin memahami pilihan selain bridge konvensional dan implan',
        ],
        problem: 'FRC menggunakan struktur diperkuat serat untuk membina semula atau menggantikan gigi, dengan komposit warna gigi. Ia minimum invasif dalam kes tertentu. Sama ada FRC sesuai untuk anda bergantung pada gigitan, kedudukan gigi dan kesihatan gigi bersebelahan — itulah tujuan penilaian.',
        assessmentIntro: 'Bagaimana kami menilai:',
        assessment: [
            'Pemeriksaan gigi yang patah atau hilang serta gigi bersebelahan',
            'Perbincangan tentang apa yang anda mahu, ditimbang dengan jujur dengan apa yang mungkin secara klinikal',
            'Semua pilihan yang munasabah di atas meja — FRC, zirconia bridge, pilihan konvensional',
            'Yuran diterangkan secara bertulis sebelum apa-apa diputuskan',
        ],
        optionsIntro: 'Pilihan yang kami bincangkan pada penilaian:',
        options: [
            { name: 'FRC (Fibre Reinforced Composite)', text: 'Penyelesaian warna gigi yang diperkuat serat, dibina di kerusi rawatan dalam kes tertentu. Minimum invasif — tetapi tidak sesuai untuk setiap situasi.' },
            { name: 'Zirconia bridge', text: 'Bridge seramik yang kuat mungkin dipertimbangkan, bergantung pada keadaan klinikal anda. Lihat halaman zirconia kami.' },
            { name: 'Pilihan lain', text: 'Bridge konvensional atau pendekatan lain mungkin lebih wajar untuk sesetengah pesakit. Penilaian yang menentukan, bukan pemasaran.' },
        ],
        knowIntro: 'Apa yang pesakit patut tahu:',
        know: [
            'FRC tidak sesuai untuk setiap kes — daya gigitan, kedudukan gigi dan gigi bersebelahan semuanya penting',
            'Ia kerap disiapkan tanpa memotong gigi bersebelahan — tetapi sama ada itu terpakai untuk anda ialah soalan klinikal, bukan janji',
            'Penjagaan dan ketahanan berbeza mengikut kes; doktor akan terangkan apa yang FRC boleh dan tidak boleh tawarkan untuk situasi anda',
        ],
        followup: 'Kerja FRC disemak seperti restorasi lain: pada lawatan berkala, dan setiap kali anda perasan perubahan. Hubungi klinik jika ada yang terasa berbeza.',
        faqs: [
            { q: 'Gigi depan saya patah — apakah pilihan saya?', a: 'Pilihan mungkin termasuk FRC, crown, bridge atau pendekatan lain, bergantung pada cara gigi patah dan kesihatannya keseluruhan. Datang untuk penilaian — kami susun pilihannya dengan jujur.' },
            { q: 'Adakah FRC hanya untuk gigi depan?', a: 'FRC kebanyakannya dibincangkan untuk situasi gigi depan, di mana daya gigitan lebih kecil. Sama ada ia sesuai untuk bahagian lain ialah soalan klinikal untuk penilaian.' },
            { q: 'Berapa lama FRC bridge tahan?', a: 'Ia berbeza mengikut kes, gigitan dan penjagaan. Tiada doktor yang jujur memberi jangka hayat tetap tanpa memeriksa — kami beritahu apa yang situasi anda tunjukkan.' },
            { q: 'Adakah prosedurnya menyakitkan?', a: 'Kerja FRC secara amnya prosedur yang lembut dalam kes tertentu, tetapi setiap mulut berbeza. Kami terangkan apa yang dijangkakan sebelum bermula — anda putuskan selepas itu.' },
        ],
        intlNote: 'Rawatan restoratif terpilih — termasuk FRC — antara sebab pesakit dari Indonesia/Batam datang ke klinik. Lihat halaman Indonesia/Batam.',
    },
    zh: {
        name: 'FRC 纤维加固复合树脂',
        short: '无需大手术的前牙修复选择（视情况而定）。',
        metaTitle: 'FRC —— 门牙断裂或缺失 | Irma Ariandi 牙科诊所 · 新山',
        metaDesc: '门牙断了或缺失？用患者听得懂的语言解释 FRC（纤维加固复合树脂）—— 是什么、适合谁、有什么替代方案。',
        kicker: '修复治疗',
        heroTitle: '门牙断裂或缺失？用大白话解释什么是 FRC。',
        heroSub: 'FRC（纤维加固复合树脂）在特定情况下，可作为门牙缺失或断裂的一种现代修复选择。我们从这个"问题"本身讲起 —— 因为您搜索的其实是它。',
        whoIntro: '向我们询问 FRC 的患者通常：',
        who: [
            '门牙缺失，希望在不做大手术的情况下修复',
            '门牙断裂，或可考虑纤维加固方案',
            '想了解传统牙桥与种植牙之外的替代选项',
        ],
        problem: 'FRC 使用纤维加固结构，以牙色复合树脂重建或替代牙齿，在选定病例中属于微创方式。它是否适合您，取决于咬合力、牙齿位置与邻牙健康 —— 这正是评估要回答的问题。',
        assessmentIntro: '我们的评估包括：',
        assessment: [
            '检查断裂或缺失的牙齿及其邻牙',
            '把您的期望与临床可行性诚实对照讨论',
            '把所有合理选项摆上台面 —— FRC、氧化锆牙桥、传统方案',
            '在决定之前，书面解释收费',
        ],
        optionsIntro: '评估时讨论的选择：',
        options: [
            { name: 'FRC（纤维增强复合树脂）', text: '在合适病例中椅旁制作的纤维增强牙色修复体。微创 —— 但并非适合所有情况。' },
            { name: '氧化锆桥', text: '根据您的临床情况，也可能考虑坚固的陶瓷桥。请参阅我们的氧化锆页面。' },
            { name: '其他选择', text: '对部分患者而言，传统桥或其他方式可能更合适。由评估决定，而非营销。' },
        ],
        knowIntro: '患者须知：',
        know: [
            'FRC 并非适合每个病例 —— 咬合力、牙齿位置与邻牙状况都很重要',
            '它常常无需磨小邻牙即可完成 —— 但这对您是否适用是临床问题，不是承诺',
            '维护与耐用度因病例而异；医生会说明 FRC 在您的情况下能做什么、不能做什么',
        ],
        followup: 'FRC 修复与所有修复体一样需要复查：常规复诊时，以及发现变化时随时联系诊所。',
        faqs: [
            { q: '我的门牙断了 —— 有哪些选择？', a: '视断裂方式与牙齿整体健康状况而定，选项可能包括 FRC、牙冠、牙桥或其他方案。来做评估，我们会诚实地把选项摆清楚。' },
            { q: 'FRC 只用于门牙吗？', a: 'FRC 多用于咬合力较小的前牙区域。其他部位是否适用，是评估时的临床问题。' },
            { q: 'FRC 牙桥能用多久？', a: '因病例、咬合与家庭护理而异。没有诚实的医生会在不检查的情况下报一个固定年限 —— 我们会说明您的情况预示什么。' },
            { q: '过程会痛吗？', a: '在选定病例中 FRC 通常是很温和的操作，但每口牙都不同。开始前我们会解释预期 —— 由您来决定。' },
        ],
        intlNote: '精选修复治疗（包括 FRC）是印尼/巴淡岛患者来诊所的原因之一。请查看印尼/巴淡岛专页。',
    },
    ta: {
        name: 'FRC',
        short: 'பெரிய அறுவை இல்லாத முன் பல் மாற்று (சில நிலைகளில்).',
        metaTitle: 'FRC — முன் பல் உடைந்தது / இல்லை | இர்மா அரியாண்டி, ஜொகூர் பாரு',
        metaDesc: 'முன் பல் உடைந்ததா? FRC (Fibre Reinforced Composite) எளிய மொழியில் விளக்கம்.',
        kicker: 'மீட்டமைப்பு',
        heroTitle: 'முன் பல் உடைந்ததா அல்லது இல்லையா? FRC என்றால் என்ன — எளிய மொழியில்.',
        heroSub: 'FRC என்பது தேர்ந்தெடுத்த சூழ்நிலைகளில் இல்லாத முன் பல்லை மாற்றக்கூடிய நவீன விருப்பம். நாங்கள் பிரச்சனையிலிருந்தே தொடங்குகிறோம்.',
        whoIntro: 'FRC பற்றிக் கேட்கும் நோயாளிகள்:',
        who: [
            'அறுவை இல்லாமல் முன் பல்லை மாற்ற விரும்புவோர்',
            'முன் பல் உடைந்து, ஃபைபர் தீர்வு கருதப்படக்கூடியவர்கள்',
            'மாற்று விருப்பங்களை அறிய விரும்புவோர்',
        ],
        problem: 'FRC ஃபைபர்-வலுவூட்டப்பட்ட அமைப்புடன், பல் நிற கம்போசிட் மூலம் பல்லை மீட்டமைக்கிறது. உங்களுக்குப் பொருந்துமா என்பது கடித்தல், பல்லின் இடம், அண்டைப் பற்களைப் பொறுத்தது.',
        assessmentIntro: 'எங்கள் மதிப்பீடு:',
        assessment: [
            'உடைந்த/இல்லாத பல் மற்றும் அண்டைப் பற்களின் பரிசோதனை',
            'அனைத்து நியாயமான விருப்பங்களும் மேசையில் — FRC, சிர்க்கோனியா பிரிட்ஜ், பிற',
            'முடிவுக்கு முன்பே கட்டணம் எழுத்தில் விளக்கம்',
        ],
        optionsIntro: 'மதிப்பீட்டில் விவாதிக்கும் விருப்பங்கள்:',
        options: [
            { name: 'FRC (Fibre Reinforced Composite)', text: 'தேர்ந்தெடுக்கப்பட்ட நிலைகளில் நாரிழை வலுப்படுத்தப்பட்ட, பல் நிற தீர்வு. குறைந்த அறுவை — ஆனால் எல்லா நிலைகளுக்கும் பொருத்தமல்ல.' },
            { name: 'Zirconia bridge', text: 'உங்கள் மருத்துவ நிலையைப் பொறுத்து வலுவான செராமிக் பாலம் பரிசீலிக்கப்படலாம். எங்கள் zirconia பக்கத்தைப் பாருங்கள்.' },
            { name: 'மற்ற விருப்பங்கள்', text: 'சில நோயாளிகளுக்கு வழக்கமான பாலங்கள் அல்லது வேறு முறைகள் ஏற்றவையாக இருக்கலாம். முடிவு மதிப்பீட்டால் — விளம்பரத்தால் அல்ல.' },
        ],
        knowIntro: 'நோயாளிகள் அறிந்திருக்க வேண்டியவை:',
        know: [
            'FRC எல்லா நிலைகளுக்கும் பொருந்தாது',
            'அண்டைப் பற்களை அரைக்காமல் பெரும்பாலும் செய்யப்படுகிறது — ஆனால் அது ஒரு மருத்துவக் கேள்வி',
            'ஆயுள் வழக்கு வாரியாக வேறுபடும்; மருத்துவர் விளக்குவார்',
        ],
        followup: 'மாற்றம் கண்டால் கிளினிக்கைத் தொடர்பு கொள்ளுங்கள்.',
        faqs: [
            { q: 'என் முன் பல் உடைந்தது — விருப்பங்கள் என்ன?', a: 'உடைந்த விதம் மற்றும் பல்லின் ஆரோக்கியத்தைப் பொறுத்து FRC, கிரீடம், பிரிட்ஜ் ஆகியவை கருதப்படலாம். மதிப்பீட்டுக்கு வாருங்கள்.' },
            { q: 'FRC எவ்வளவு காலம் நீடிக்கும்?', a: 'வழக்கு, கடித்தல், பராமரிப்பைப் பொறுத்தது. பரிசோதனையின்றி உறுதியான எண் சொல்வது நேர்மையல்ல.' },
            { q: 'அதிக வலி உள்ளதா?', a: 'தேர்ந்தெடுத்த நிலைகளில் FRC மென்மையான செயல்முறை; ஆனால் தொடங்குவதற்கு முன் விளக்குவோம்.' },
        ],
        intlNote: 'FRC உள்ளிட்ட தேர்ந்தெடுத்த மீட்டமைப்பு சிகிச்சைகளுக்காக இந்தோனேசியா/பத்தாம் நோயாளிகள் வருகிறார்கள்.',
    },
};
